<template>
  <div :class="['px-0', this.isBelowSmallestBreakpoint ? 'py-2' : 'py-0']">
    <a
      v-if="!adData.body"
      :href="adData.redirect_url"
      :target="adData.target"
      @click="sendClickAnalytics('ad_image_clicked')"
      @contextmenu.prevent="
        openLink();
        sendClickAnalytics('ad_image_clicked');
      "
    >
      <ConditionalCard
        :cls="cls"
        :wrap="!!(adData.metadata && adData.metadata.card)"
      >
        <v-img
          v-observe-visibility="{
            callback: visibilityChanged,
            once: true
          }"
          :alt="adData.alt_text"
          :max-height="adData.height > 0 ? adData.height : 'auto'"
          :max-width="adData.width > 0 ? adData.width : 'auto'"
          :src="adData.image_url"
          cover
          width="100%"
        />
      </ConditionalCard>
    </a>
    <ConditionalCard
      v-if="adData.body"
      :cls="cls"
      :wrap="!!(adData.metadata && adData.metadata.card)"
    >
      <div :style="'position: relative'" @click="videoHandling">
        <div
          ref="adDataBody"
          v-observe-visibility="{
            callback: visibilityChanged,
            once: true
          }"
          v-html="sanitize(adData.body)"
        />
        <div v-if="!playing" class="videoButton" />
      </div>
    </ConditionalCard>

    <v-btn
      v-if="adData.metadata && adData.metadata.button"
      :block="true"
      :href="adData.redirect_url"
      :target="adData.target"
      class="mt-6"
      color="info"
      variant="outlined"
      @click="sendClickAnalytics('ad_button_clicked')"
      @contextmenu.prevent="
        openLink();
        sendClickAnalytics('ad_button_clicked');
      "
    >
      {{ adData.metadata.button }}
    </v-btn>
  </div>
</template>

<script>
import { mapState, mapActions } from 'pinia';
import ConditionalCard from '@/components/ConditionalCard';
import { sendAnalytics } from '@/services/analytics';
import { useResponsiveBreakpointsStore } from '@/stores/responsiveBreakpoints.js';
import { useTrackingDataStore } from '@/stores/trackingData.js';
import DOMPurify from 'dompurify';

export default {
  name: 'AdItem',
  components: {
    ConditionalCard
  },
  props: {
    adData: {
      type: Object,
      default: null
    }
  },
  data: function () {
    return {
      played: false,
      playing: false
    };
  },
  computed: {
    ...mapState(useTrackingDataStore, {
      trackingData: 'data'
    }),
    ...mapState(useResponsiveBreakpointsStore, ['isBelowSmallestBreakpoint']),
    cls() {
      if (this.adData.metadata && this.adData.metadata.align) {
        const align = this.adData.metadata.align;
        if (align === 'left') return 'd-flex justify-start';
        else if (align === 'right') return 'd-flex justify-end';
      }
      return 'd-flex justify-center';
    }
  },
  methods: {
    sanitize: DOMPurify.sanitize,
    ...mapActions(useTrackingDataStore, ['triggerTrackingUrl']),
    triggerViewableUrl() {
      if (this.adData.viewable_url) {
        this.sendClickAnalytics('ad_viewable');
        this.triggerTrackingUrl({ url: this.adData.viewable_url });
      }
    },
    triggerEligibleUrl() {
      if (this.adData.eligible_url) {
        this.sendClickAnalytics('ad_eligible');
        this.triggerTrackingUrl({ url: this.adData.eligible_url });
      }
    },
    visibilityChanged(isVisible) {
      if (isVisible) {
        this.triggerViewableUrl();
      }
    },
    videoHandling(evt) {
      const videoElement = evt.currentTarget.querySelector('video');
      this.playing = videoElement.paused;

      if (videoElement.paused) {
        videoElement.play();
        if (!this.played) {
          this.sendClickAnalytics('video_ad_started');
          this.played = true;
        }
      } else {
        videoElement.pause();
        window.open(this.adData.redirect_url, this.adData.target);
        this.sendClickAnalytics('video_ad_clicked');
      }
    },
    sendClickAnalytics(eventName) {
      sendAnalytics(this.trackingData, 'ads', eventName, {
        banner_id: this.adData.banner_id,
        alt_text: this.adData.alt_text
      });
    },
    openLink() {
      window.open(this.adData.redirect_url, '_blank');
    }
  },
  mounted() {
    this.triggerEligibleUrl();
    if (this.$refs.adDataBody) {
      const videoElement = this.$refs.adDataBody.querySelector('video');
      this.playing = videoElement?.paused === false;
      if (this.playing) {
        this.triggerViewableUrl();
        this.played = true;
      }
    }
  }
};
</script>

<style scoped>
.videoButton {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-image: url('/video-play-button.svg');
  background-position: center;
}
</style>
